import React from "react";

export default function Header() {
  return (
    <div className="schedule-template-header">
      <div className="schedule-header-logo">
        <h2>SMART CARE-POLYCLINIC AND DIAGNOSTIC CENTER</h2>
        <span>Gulod St., San Pedro, Gen. Tinio, Nueva Ecija</span>
      </div>
      <div className="schedule-header-date">
        <h3>S C H E D U L E</h3>
        <span>July 1 – 15, 2025</span>
      </div>
    </div>
  );
}
